import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { ReactComponent as ArrowUp } from 'style/_assets/icons/arrow-up.svg';
import { ReactComponent as ArrowDown } from 'style/_assets/icons/arrow-down.svg';
import Label from 'components/form/Label/Label';
import { formatDateMMDDYY } from 'helpers/dateHelper';

const ScoreChangeLabel = props => {
  const { scoreDate, scoreChange, isPotentialView, isFreeOr1BUser } = props;

  const potentialScoreLabel = isFreeOr1BUser
    ? 'Updated Daily'
    : 'Next Update: ';

  return (
    <FlexContainer className="justify-center">
      <span className={isPotentialView ? '' : 'margT5'}>
        {scoreChange > 0 && (
          <div className="fontGreen300">
            <ArrowUp style={{ marginTop: '-3px' }} />
            {scoreChange}
          </div>
        )}
        {scoreChange < 0 && (
          <div className="fontRed100">
            <ArrowDown style={{ marginTop: '-3px' }} />
            {Math.abs(10)}
          </div>
        )}
        {scoreChange === 0 && (
          <Label
            className={
              'caption m-text-10 system_neutral_n250_text margT6 margB10'
            }
          >
            {`${potentialScoreLabel} ${
              scoreDate ? formatDateMMDDYY(new Date(scoreDate)) : ''
            }`}
          </Label>
        )}
      </span>
    </FlexContainer>
  );
};

export default ScoreChangeLabel;
